import Shape from './Shape';

export default class Polygon extends Shape {
  public type = 6
  constructor(item: any, index: number) {
    super(item, index)
  }
  get ctrlsData() {
    return this.coor;
  }
}
